import Link from "next/link";
import { Ruler } from "lucide-react";

export function DesignGuidance({ notes = [] }: { notes?: string[] }) {
  return <aside aria-label="Before you buy" className="rounded-xl border border-clay/25 bg-clay/5 p-4 text-sm">
    <div className="flex items-start gap-3">
      <Ruler className="w-5 h-5 shrink-0 text-clay mt-0.5" aria-hidden="true" />
      <p><strong>AI concept — not to scale.</strong> Check furniture dimensions against your room and delivery access before buying.</p>
    </div>
    <details className="mt-3 pl-8 text-ink-soft">
      <summary className="cursor-pointer text-xs font-semibold text-ink">Before you buy: measurements &amp; prices</summary>
      <div className="mt-3 space-y-2 text-xs leading-relaxed">
        <p>The image is AI-generated inspiration, not a measured plan. Apparent size, spacing, colour and placement can be inaccurate. Room-width estimates do not make the image dimensionally accurate.</p>
        <p>For large pieces, check the retailer’s exact width, depth and height, measure the intended space, and allow for doors, walkways, radiators and fireplaces. Check delivery doors, stairs and lifts too. Use a qualified fitter for electrical, structural or fitted work.</p>
        {notes.map(note => <p key={note}>{note}</p>)}
        <p>Paint quantities, lighting suitability and installation requirements need checking for your actual room. <Link href="/terms#measurements" className="underline underline-offset-2">Read the sizing terms</Link>.</p>
      </div>
    </details>
  </aside>;
}
